import React from 'react';
import InlineSpinner from '../loader/InlineSpinner';

export default function Button({
  children, variant = 'primary', size = 'md', block = false, neon = false,
  loading = false, disabled = false, onClick, type = 'button', className = ''
}) {
  const cls = [
    'btn',
    variant === 'primary' ? 'btn-primary' : '',
    variant === 'ghost'   ? 'btn-ghost' : '',
    variant === 'danger'  ? 'btn-danger' : '',
    variant === 'success' ? 'btn-success' : '',
    size === 'lg' ? 'btn-lg' : '',
    size === 'sm' ? 'btn-sm' : '',
    block ? 'btn-block' : '',
    neon ? 'btn-neon' : '',
    className
  ].filter(Boolean).join(' ');
  return (
    <button type={type} className={cls} onClick={onClick} disabled={disabled || loading}>
      {loading && <InlineSpinner />}
      {children}
    </button>
  );
}
